var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnergy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.895,
    height: 29.895,
    viewBox: "0 0 29.895 29.895",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1,14.947A13.966,13.966,0,0,1,14.947,1a13.817,13.817,0,0,1,10.99,5.481H22.919a.5.5,0,0,0,0,1h3.986a.423.423,0,0,0,.044-.009.468.468,0,0,0,.1-.019.491.491,0,0,0,.093-.038.331.331,0,0,0,.041-.017c.014-.009.021-.023.034-.034a.463.463,0,0,0,.072-.071.489.489,0,0,0,.052-.077.45.45,0,0,0,.035-.086.419.419,0,0,0,.02-.1.375.375,0,0,0,.01-.047V2.989a.5.5,0,0,0-1,0V5.472A14.8,14.8,0,0,0,14.947,0,14.959,14.959,0,0,0,.733,19.584a.5.5,0,0,0,.474.344.507.507,0,0,0,.154-.025.5.5,0,0,0,.319-.628A13.928,13.928,0,0,1,1,14.947Z",
    fill: "#0080ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.858,105.228a.5.5,0,0,0,.606-.189l7.474-11.46a.5.5,0,0,0-.5-.763l-5.284.88,1.372-7.776a.5.5,0,0,0-.917-.343l-7.474,12.456a.5.5,0,0,0,.509.748l5.267-.877-1.353,6.766A.5.5,0,0,0,149.858,105.228Zm-3.313-7.607,5.532-9.221-1.026,5.817a.5.5,0,0,0,.572.578l4.86-.81-5.441,8.342.987-4.937a.5.5,0,0,0-.488-.6.454.454,0,0,0-.082.007Z",
    transform: "translate(-136.594 -80.352)",
    fill: "#0080ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.309,169.633a.5.5,0,0,0-.946.315,13.9,13.9,0,0,1-24.23,12.877h3.018a.5.5,0,1,0,0-1H43.165a.4.4,0,0,0-.043.009.469.469,0,0,0-.1.02.529.529,0,0,0-.092.037c-.013.007-.028.008-.041.017s-.021.023-.034.034a.463.463,0,0,0-.072.071.485.485,0,0,0-.052.077.532.532,0,0,0-.056.185c0,.016-.009.03-.009.047v3.986a.5.5,0,0,0,1,0v-2.483a14.8,14.8,0,0,0,11.46,5.473,14.958,14.958,0,0,0,14.186-19.669Z",
    transform: "translate(-40.176 -159.407)",
    fill: "#0080ff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.f138eb4f.svg";
export { ForwardRef as ReactComponent };